import * as firebase from "firebase/app";
import "firebase/firestore";

import "./init";

const { firestore } = firebase;
const db = typeof window !== "undefined" ? firestore() : null;

if (db !== null && process.env.GATSBY_FIREBASE_FIRESTORE_HOST !== undefined) {
  db.settings({
    host: process.env.GATSBY_FIREBASE_FIRESTORE_HOST,
    ssl: false,
  });
}

export { db as default, firestore };
